import React, { useState, useEffect } from "react";
import { IoIosArrowUp } from "react-icons/io";
import Image from "next/image";
import { useDispatch, useSelector } from "react-redux";
import { useMemo } from "react";
import axios from "axios";
import StripeCheckout from "./StripeCheckout";
import Loading from "../../Loading";
import { ethers, Wallet } from "ethers";
import getMintingDetails from "../../../utils/getMintingDetails";
import { useActiveAccount } from "thirdweb/react";
import web3Config from "../../../web3Config";
import web3ErrorHandler from "../../../utils/web3ErrorHandler";
import { FaArrowLeft } from "react-icons/fa6";
import { useRouter } from "next/router";
import getSignatureForMinting from "../../../utils/getSignatureForMinting";
import toast from "react-hot-toast";
import Link from "next/link";

function WalletPage() {
  // const signer = useSigner();
  const connectedAddress = useActiveAccount();
  const router = useRouter();

  // const chain_id = process.env.NEXT_PUBLIC_ACTIVE_CHAIN_ID;
  const chain_id = 137;
  const SIGNING_DOMAIN_NAME = "WEB3CLUB";
  const SIGNING_DOMAIN_VERSION = "1";
  const DOMAIN_REGISTRY_CONTRACT_ADDRESS = web3Config.contractAddress;
  const abi = web3Config.abi;

  const [show, setShow] = useState(false);

  const [card, setCard] = useState(false);
  const [checkoutLoading, setCheckoutLoading] = useState(false);
  const [signature, setSignature] = useState();
  const [totalAmountInMatic, settotalAmountInMatic] = useState(0);
  const [mintConfig, setMintConfig] = useState();

  const [isloading, setIsLoading] = useState(false);

  const dispatch = useDispatch();

  const { cartItems, netzyloWallet } = useSelector((state) => state.cart);
  // console.log(cartItems);
  function cartItemstoArray() {
    let temp = [];

    for (let i = 0; i < cartItems.length; i++) {
      temp[i] = cartItems[i].name;
    }
    return temp;
  }

  const totalPrice = useMemo(() => {
    if (cartItems.length > 0) {
      return cartItems.reduce((acc, curr) => {
        const price = curr.price ? parseFloat(curr.price) : 0;
        return acc + (curr.quantity ? curr.quantity * curr.price : price);
      }, 0);
    }
  }, [cartItems]);

  async function getDomainNames() {
    let items = [];
    for (let i = 0; i < cartItems.length; i++) {
      items.push(cartItems[i].fullname);
    }
    return items;
    //return await getMintingDetails(cartItems);
  }
  const connectWallet = async () => {
    if (window.ethereum) {
      try {
        await window.ethereum.request({ method: "eth_requestAccounts" });
        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const network = await provider.getNetwork();
        console.log("network: " + JSON.stringify(network));
        if (network.chainId !== chain_id) {
        }
        runRegisterDomainFunction();
      } catch (error) {
        console.error(error);
      }
    } else {
      console.log("MetaMask is not installed!");
    }
  };

  const runRegisterDomainFunction = async () => {
    try {
      if (isloading) {
        alert("Already Processing your tx");
        return;
      }
      setIsLoading(true);
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const contract = new ethers.Contract(
        DOMAIN_REGISTRY_CONTRACT_ADDRESS,
        abi,
        signer
      );
      let tempMintConfig;
      if (!mintConfig) {
        let netzyloConnectedAddress = connectedAddress;
        if (netzyloConnectedAddress == undefined) {
          //If we are unable to fetch connected wallet address, Sometime it returns undefined even if wallet is connected
          alert("Unable to fetch email generated address");
          return;
        }
        let domainNames = await getDomainNames();

        let to_Addresses = [];
        for (let i = 0; i < domainNames.length; i++) {
          to_Addresses[i] = netzyloConnectedAddress;
        }

        let values = await getSignatureForMinting(
          domainNames,
          totalPrice,
          netzyloConnectedAddress,
          false
        );
        let signature = values.sig;
        tempMintConfig = {
          domainNames,
          to_Addresses,
          random_int: values.random_int.toString(),
          amount: values.matic_in_wei.toString(),
          sig: signature.toString(),
        };
        console.log(tempMintConfig);
        setMintConfig(tempMintConfig);
      } else {
        tempMintConfig = mintConfig;
      }

      //Multiple errors could occur here, they are being handled in web3ErrorHandler()
      const tx = await contract.registerDomain(
        tempMintConfig.domainNames,
        tempMintConfig.to_Addresses,
        tempMintConfig.random_int.toString(),
        tempMintConfig.amount,
        tempMintConfig.sig,
        {
          value: tempMintConfig.amount,
        }
      );

      await tx.wait();
      setIsLoading(false);
      console.log("Transaction successful:", tx);
      alert("Transaction successful");
    } catch (error) {
      console.log(error);
      setIsLoading(false);
      web3ErrorHandler(error);
    }
  };

  async function shopifyOrder() {
    axios
      .post("/api/shopify/products", {
        domains: cartItems,
        netzyloWallet,
      })
      .then((response) => {
      })
      .catch((error) => {
        console.error("Error fetching products:", error);
      });
  }

  return (
    <div className=" max-w-[1200px] md:mx-auto mb-20">
      <div className="gradient-box bg-white dark:bg-jacarta-900 grid md:grid-cols-2 gap-4 p-4">
        <div className="mt-10 md:mt-0 md:border md:border-b-gray-300 dark:md:border-r-gray-200 md:border-r-gray-300 md:border-y-0 md:border-l-0 md:pr-4 pt-0">
          <>
            {/* <div className="text-center">
              <div className="my-6 pr-2">
               
                <div className="dark:bg-jacarta-900  dark:border-jacarta-600 border-jacarta-900 border-1 border-b-0   border bg-white  mb-0 border-x-0 text-center transition-shadow hover:shadow-lg mt-[2.5rem]"></div>
                <div
                  className="dark:border-jacarta-600  text-sm flex items-center justify-center border-jacarta-900 mx-auto mb-3  -mt-[1.2rem] h-[2.5rem] w-[2.5rem] rounded-full border bg-white dark:bg-jacarta-900 text-jacarta-900 dark:text-white"
                  alt="wallet"
                >
                  {" "}
                  OR
                </div>
              </div>
            </div> */}
            <div className="mb-12">
              <p
                onClick={() => router.back()}
                className="m-0 text-base text-jacarta-900 dark:text-gray-400 flex items-center mb-2  gap-2 cursor-pointer font-medium  w-fit"
              >
                <FaArrowLeft /> Back
              </p>
            </div>
            {/* <div className="mb-4">
              <h5 className="modal-title !text-jacarta-900 dark:!text-white  mb-4" id="buyDomainsModalLabel">
                Personal Information
              </h5>
              <div className="my-6">
                <div className="grid md:grid-cols-2 gap-3">
                  <input
                    placeholder="First name"
                    type="text"
                    className="mb-6 dark:bg-jacarta-900 border-jacarta-300 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white px-3"
                  />
                  <input
                    placeholder="Last name"
                    type="text"
                    className="mb-6 dark:bg-jacarta-900 border-jacarta-300 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white px-3"
                  />
                </div>

                <input
                  placeholder="Address"
                  type="text"
                  className="mb-6 dark:bg-jacarta-900 border-jacarta-300 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white px-3"
                />
                <input
                  placeholder="Apartment, Suite, etc. (optional)"
                  type="text"
                  className="mb-6 dark:bg-jacarta-900 border-jacarta-300 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white px-3"
                />
                <div className="grid md:grid-cols-3 gap-3">
                  <input
                    placeholder="City"
                    type="text"
                    className="mb-3 dark:bg-jacarta-900 border-jacarta-300 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white px-3"
                  />
                  <input
                    placeholder="State"
                    type="text"
                    className="mb-3 dark:bg-jacarta-900 border-jacarta-300 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white px-3"
                  />
                  <input
                    placeholder="Zip code"
                    type="number"
                    className="mb-3 dark:bg-jacarta-900 border-jacarta-300 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white px-3"
                  />
                </div>
                <input
                  placeholder="Country"
                  type="text"
                  className="mb-6 dark:bg-jacarta-900 border-jacarta-300 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white px-3"
                />
              </div>
            </div> */}

            {/* <div className=" mb-6">
              <h5 className="modal-title !text-jacarta-900 dark:!text-white mb-4" id="buyDomainsModalLabel">
                Contact Information
              </h5>
              <input
                placeholder="Email"
                type="email"
                className="mb-6 dark:bg-jacarta-900 border-jacarta-300 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white px-3"
              />
              <input
                placeholder="Phone"
                type="text"
                className="mb-6 dark:bg-jacarta-900 border-jacarta-300 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 hover:ring-2 dark:text-white px-3"
              />

              <div className="flex items-center gap-2">
                <input type="checkbox" id="myCheckbox1" className="w-5 h-5 text-indigo-600 border-gray-300 rounded focus:ring-indigo-500" />
                <label for="myCheckbox1" className="text-xs md:text-[16px] lg:text-base ml-2 text-gray-300 dark:text-white cursor-pointer">
                  Email or Text me with news and offers
                </label>
              </div>
            </div> */}
            <div className="">
              <h5
                className="modal-title !text-jacarta-900 dark:!text-white"
                id="buyDomainsModalLabel"
              >
                Payment
              </h5>

              <div className="grid grid-cols-1 gap-3 mt-3">
                {/* <div
                  onClick={() => setCard(false)}
                  className="flex items-center gap-2 dark:border-[#ffffff14] border-[#00000014] border-[1px]      bg-white  dark:bg-jacarta-900 hover:dark:bg-accent/20 hover:bg-accent/20  cursor-pointer transition-all duration-200 p-1 my-2 rounded-md justify-center"
                >
                  <div className="  h-[1rem] w-[3.5rem] ">
                    <Image width={86} height={86} src={"/images/paypal.png"} className=" rounded-full my-auto" alt="wallet" />
                  </div>
                </div> */}
                <div
                  onClick={() => {
                    if (connectedAddress) {
                      setCard(true);
                      setCheckoutLoading(true);
                    } else {
                      toast.error("Please first Sign in");
                    }
                  }}
                  className="flex items-center gap-2 dark:border-[#ffffff14] border-[#00000014] border-[1px]    bg-white  dark:bg-jacarta-900 hover:dark:bg-accent/20 hover:bg-accent/20 dark:text-white  text-jacarta-900  cursor-pointer transition-all duration-200  p-1 my-2 rounded-md justify-center h-11 overflow-hidden "
                >
                  <div className="h-[2.5rem] w-[2.5rem]  flex items-center justify-center">
                    {checkoutLoading ? (
                      <div className="relative">
                        <Loading />
                      </div>
                    ) : (
                      <Image
                        width={120}
                        height={120}
                        src={"/images/cc-stripe.svg"}
                        className=" "
                        alt="wallet"
                      />
                    )}
                  </div>
                  Pay with Stripe
                </div>
                {/* <div
                  onClick={() => setCard(false)}
                  className="flex items-center gap-2 dark:border-[#ffffff14] border-[#00000014]  border-[1px]    bg-white  dark:bg-jacarta-900 hover:dark:bg-accent/20 hover:bg-accent/20  cursor-pointer transition-all duration-200  p-1 my-2 rounded-md justify-center "
                >
                  <div className="h-[2.5rem] w-[2.5rem]  ">
                    <Image width={86} height={86} src={"/images/skype.png"} className=" rounded-full " alt="wallet" />
                  </div>
                </div> */}
                {/* <div
                  onClick={() => setCard(false)}
                  className="flex items-center gap-2 dark:border-[#ffffff14] border-[#00000014] border-[1px]    bg-white  dark:bg-jacarta-900 hover:dark:bg-accent/20 hover:bg-accent/20  cursor-pointer transition-all duration-200  p-1 my-2 rounded-md justify-center "
                >
                  <div className="h-[3.5rem] w-[3.5rem] flex items-center ">
                    <Image
                      width={86}
                      height={86}
                      src={"/images/Google.png"}
                      className="h-[2.5rem] w-[2.5rem] object-contain mx-auto rounded-full "
                      alt="wallet"
                    />
                  </div>
                </div> */}
              </div>
            </div>

            {card && (
              <StripeCheckout
                setCard={setCard}
                setCheckoutLoading={setCheckoutLoading}
              />
            )}

          </>
        </div>

        <div className=" sticky self-start top-24 pt-6">
          {/* <OfferTab /> */}
          <div className="flex items-center justify-between">
            <h5
              className="modal-title !text-jacarta-900 dark:!text-white "
              id="buyDomainsModalLabel"
            >
              Order Summary
            </h5>

            {/* <p className=" text-jacarta-900 dark:text-white hover:text-accent cursor-pointer">
              Edit
            </p> */}
          </div>

          <div className="modal-body space-y-2 p-2 py-6">
            <div className="flex justify-between items-center pb-1 gap-8">
              <div className="flex items-center gap-2">
                <p className="text-sm lg:text-base text-jacarta-900 dark:text-white font-medium">
                  Item{" "}
                </p>
                <div className="border-accent w-4 h-4 text-white rounded-full bg-accent">
                  <p className="font-semibold text-center text-jacarta-800 text-sm">
                    {cartItems.length}
                  </p>
                </div>
              </div>
            </div>

            {/* Cart Items List */}
            {cartItems.map((item) => {
              if (item.type === "BROKER_SERVICE") {
                return (
                  <div
                    key={item.id}
                    className=" rounded-md border border-jacarta-100 dark:border-jacarta-600 p-2"
                  >
                    <div className="flex justify-between items-center py-1 gap-2 lg:gap-8">
                      <div className="flex-1">
                        <div className="flex items-center gap-2 mb-1">
                          <span className="text-xs px-2 py-0.5 bg-jacarta-900 text-white dark:bg-accent/10 dark:text-accent rounded-full">
                            Broker Service
                          </span>
                        </div>
                        <div className="text-sm lg:text-base font-semibold text-jacarta-900 dark:text-white">
                          {item.fullname}
                        </div>
                        <div className="text-xs text-jacarta-700 dark:text-jacarta-300">
                          with {item.metadata.brokerName}
                        </div>
                      </div>
                      <div className="text-right">
                        <div className="text-sm lg:text-base font-medium text-jacarta-900 dark:text-white">
                          ${item.price}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              }

              // Regular items remain unchanged
              return (
                <div
                  key={item.id}
                className=" rounded-md border border-jacarta-100 dark:border-jacarta-600 p-2"
                >
                  <div className="flex justify-between items-center py-1 gap-2 lg:gap-8">
                    <div className="flex items-center gap-2">
                      <div className="truncate shrink whitespace-nowrap text-ellipsis font-semibold text-jacarta-900 text-sm lg:text-base dark:text-white">
                        {item.quantity && `${item.quantity} x `}
                        {item.fullname}
                      </div>
                    </div>
                    <div className="flex items-center">
                      <div className="flex items-center flex-col gap-2">
                        <div className="text-sm lg:text-base font-medium text-jacarta-900 dark:text-white">
                          ${item.price}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}

            {/* Total Section */}
            <section className="flex flex-col text-jacarta-900 dark:text-white relative border-t border-jacarta-400 dark:border-jacarta-600">
              <div className="flex justify-between items-center mt-3 py-2 text-sm">
                <p className="text-xs lg:text-sm font-medium">Sub Total</p>
                <div className="text-right">
                  <p className="text-accent-content text-xs lg:text-sm">
                    ${totalPrice}
                  </p>
                </div>
              </div>

              <div className="flex justify-between items-center  py-2 text-sm">
                <p className="text-base lg:text-lg font-medium">Total</p>
                <div className="text-right">
                  <p className="text-accent-content text-base lg:text-lg">
                    ${totalPrice}
                  </p>
                </div>
              </div>

              <p className="mt-4 text-xs lg:text-sm">
                {/* Note that in order to get a refund you must transfer the domain back to our corporate account. All refund shall be made in the orignal
                payment method used, or in store credit. .com and .eth domains are non refundable. */}
                By completing your purchase, you agree to our  <Link href="/terms-and-conditions" className="text-accent">
                  {" "}
                  Terms and conditions
                </Link>
              </p>

            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WalletPage;
